/* mm-quick-add.js
 * 1) Direct add-to-cart for single-variant quick-add buttons ([data-mm-qa-add])
 * 2) Cart-drawer dynamic related-products carousel (excludes items already in cart)
 * Variant products open the custom quick-add drawer below.
 */
(function () {
  'use strict';

  async function emitCartUpdate(source) {
    try {
      var res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: {}, sections: ['cart-count', 'cart-drawer'], sections_url: window.location.pathname })
      });
      var cart = await res.json();
      if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { source: source || 'mm-quick-add', cart: cart, sections: cart.sections });
      }
    } catch (e) {}
  }
  window.__mmEmitCartUpdate = emitCartUpdate;

  async function refreshCartDrawer() {
    try {
      var res = await fetch(window.location.pathname + '?sections=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      var data = await res.json();
      var html = data['cart-drawer'];
      if (!html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector('#MinimogCartDrawer, .m-cart-drawer');
      var current = document.querySelector('#MinimogCartDrawer, .m-cart-drawer');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    } catch (e) {}
  }

  /* Colour-scheme classes from the cart drawer, i.e. the theme setting
   * "Drawer & popup > Color scheme" (m-gradient m-color-<scheme>).
   * Shared so the quick-add popup below matches the cart drawer. */
  function drawerSchemeClasses() {
    var host = document.querySelector('.m-cart-drawer__inner');
    var out = [];
    if (host) {
      Array.prototype.forEach.call(host.classList, function (c) {
        if (c === 'm-gradient' || c.indexOf('m-color-') === 0) out.push(c);
      });
    }
    return out;
  }
  window.__mmDrawerSchemeClasses = drawerSchemeClasses;

  /* ---- 1) Direct add to cart (single-variant products) ---- */
  function bindDirectAdd() {
    document.addEventListener('click', async function (e) {
      var btn = e.target.closest('[data-mm-qa-add]');
      if (!btn) return;
      e.preventDefault();
      if (btn.classList.contains('is-loading')) return;
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      btn.classList.add('is-loading');
      var textEl = btn.querySelector('.mm-qa-btn__text');
      var spinEl = btn.querySelector('.mm-qa-btn__spinner');
      if (spinEl) spinEl.hidden = false;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        });
        await refreshCartDrawer();
        emitCartUpdate();
        var drawer = document.querySelector('#MinimogCartDrawer, .m-cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        if (textEl) { var prev = textEl.textContent; textEl.textContent = '✓ Added'; setTimeout(function () { textEl.textContent = prev; }, 1500); }
      } catch (err) {
        console.error('mm-quick-add: add failed', err);
      } finally {
        btn.classList.remove('is-loading');
        if (spinEl) spinEl.hidden = true;
      }
    });
  }

  /* ---- 2) Cart drawer dynamic recommendations ---- */
  async function loadDrawerRecommendations(host) {
    var productId = host.getAttribute('data-seed-product-id');
    var limit = host.getAttribute('data-limit') || 6;
    var intent = host.getAttribute('data-intent') || 'related';
    var sectionId = host.getAttribute('data-section-id') || 'mm-drawer-recommendations';
    if (!productId) { host.setAttribute('hidden', ''); return; }
    try {
      var url = '/recommendations/products?section_id=' + sectionId + '&product_id=' + productId + '&limit=' + limit + '&intent=' + intent;
      var res = await fetch(url);
      var text = await res.text();
      var tmp = document.createElement('div');
      tmp.innerHTML = text;
      var inner = tmp.querySelector('[data-mm-reco-list]');
      var target = host.querySelector('[data-mm-reco-list]');
      if (inner && target) {
        target.innerHTML = inner.innerHTML;
        excludeInCart(host);
      } else {
        host.setAttribute('hidden', '');
      }
    } catch (e) { host.setAttribute('hidden', ''); }
  }

  function excludeInCart(host) {
    var inCart = (window.__mmCartProductIds || []).map(String);
    host.querySelectorAll('[data-mm-qa-row]').forEach(function (row) {
      var pid = row.getAttribute('data-product-id');
      if (inCart.indexOf(String(pid)) !== -1) row.remove();
    });
    var remaining = host.querySelectorAll('[data-mm-qa-row]').length;
    if (remaining === 0) { host.setAttribute('hidden', ''); }
    else { host.removeAttribute('hidden'); initCarousel(host); }
  }

  function initCarousel(host) {
    if (host.getAttribute('data-carousel-ready')) return;
    host.setAttribute('data-carousel-ready', '1');
    var track = host.querySelector('[data-mm-reco-list]');
    var prev = host.querySelector('[data-mm-reco-prev]');
    var next = host.querySelector('[data-mm-reco-next]');
    if (!track) return;
    function step() { return Math.max(track.clientWidth * 0.8, 220); }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  }

  function initDrawerRecos() {
    document.querySelectorAll('[data-mm-reco-host]').forEach(function (host) {
      if (host.getAttribute('data-loaded')) return;
      host.setAttribute('data-loaded', '1');
      loadDrawerRecommendations(host);
    });
  }

  /* Observe the cart drawer so recos load whenever its content is (re)rendered */
  function observeDrawer() {
    var drawer = document.querySelector('#MinimogCartDrawer, .m-cart-drawer');
    if (!drawer) return;
    var obs = new MutationObserver(function () {
      // debounce a touch
      clearTimeout(window.__mmRecoT);
      window.__mmRecoT = setTimeout(initDrawerRecos, 150);
    });
    obs.observe(drawer, { childList: true, subtree: true });
  }

  function init() {
    window.__mmRefreshCartDrawer = refreshCartDrawer;
    bindDirectAdd();
    initDrawerRecos();
    observeDrawer();
    try {
      if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
        window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, function () { setTimeout(initDrawerRecos, 250); });
        window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.openCartDrawer, function () { setTimeout(initDrawerRecos, 250); });
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


/* mm-quick-add-drawer.js
 * Custom slide-in quick-add panel (side on desktop, bottom sheet on mobile).
 * Opens for multi-variant products from Buy-it-with / related rows via [data-mm-qa-open].
 * Fetches /products/{handle}.js, renders options, sticky Add-to-cart + Buy-it-now footer.
 * Panel adopts the cart drawer's colour scheme (Drawer & popup > Color scheme) and the
 * footer buttons use the theme's default .m-button styling.
 */
(function () {
  'use strict';
  var MONEY_FMT = (window.MinimogSettings && window.MinimogSettings.money_format) || (window.Shopify && window.Shopify.money_format) || '\${{amount}}';
  function formatMoney(cents) {
    var value = (cents / 100);
    var fmt = MONEY_FMT;
    function num(n, dec) { return (Math.round(n * 100) / 100).toFixed(dec == null ? 2 : dec); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      switch (key) {
        case 'amount': return num(value, 2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        case 'amount_no_decimals': return num(value, 0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        case 'amount_with_comma_separator': return num(value, 2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        case 'amount_no_decimals_with_comma_separator': return num(value, 0).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        default: return num(value, 2);
      }
    });
  }

  var CHEVRON_LEFT = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5 8 12l7 7"/></svg>';
  var CHEVRON_RIGHT = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>';

  var root, panel, overlay, current = { product: null, variant: null, selected: {} };

  /* Mirror the cart drawer's colour scheme onto the panel so the popup follows
   * the "Drawer & popup > Color scheme" theme setting. */
  function applyScheme() {
    if (!panel) return;
    var classes = (window.__mmDrawerSchemeClasses && window.__mmDrawerSchemeClasses()) || [];
    if (!classes.length) return;
    Array.prototype.slice.call(panel.classList).forEach(function (c) {
      if (c.indexOf('m-color-') === 0 && classes.indexOf(c) === -1) panel.classList.remove(c);
    });
    classes.forEach(function (c) { panel.classList.add(c); });
  }

  function ensureDom() {
    if (root && document.body.contains(root)) { applyScheme(); return; }
    if (root && !document.body.contains(root)) { document.body.appendChild(root); applyScheme(); return; }
    root = document.createElement('div');
    root.className = 'mm-qd';
    root.setAttribute('data-mm-qd', '');
    root.innerHTML =
      '<div class="mm-qd__overlay" data-mm-qd-overlay></div>' +
      '<aside class="mm-qd__panel" role="dialog" aria-modal="true" aria-label="Quick add" data-mm-qd-panel>' +
      '  <button type="button" class="mm-qd__close" data-mm-qd-close aria-label="Close">&times;</button>' +
      '  <div class="mm-qd__scroll" data-mm-qd-scroll></div>' +
      '  <div class="mm-qd__footer" data-mm-qd-footer></div>' +
      '</aside>';
    document.body.appendChild(root);
    panel = root.querySelector('[data-mm-qd-panel]');
    overlay = root.querySelector('[data-mm-qd-overlay]');
    applyScheme();
    overlay.addEventListener('click', close);
    root.querySelector('[data-mm-qd-close]').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });
  }

  function open() { ensureDom(); applyScheme(); root.classList.add('is-open'); document.documentElement.classList.add('mm-qd-lock'); }
  function close() { if (!root) return; root.classList.remove('is-open'); document.documentElement.classList.remove('mm-qd-lock'); }

  function findVariant(product) {
    var opts = current.selected;
    return product.variants.find(function (v) {
      return product.options.every(function (name, i) { return v.options[i] === opts[i]; });
    }) || null;
  }

  function renderMedia(product) {
    var media = product.media && product.media.length ? product.media : (product.images || []).map(function (src) { return { src: src, preview_image: { src: src } }; });
    if (!media.length && product.featured_image) media = [{ src: product.featured_image }];
    // Move the selected variant's featured image to the front so it shows first.
    var variant = current && current.variant;
    var vImg = variant && (variant.featured_media || variant.featured_image);
    if (vImg) {
      var vId = vImg.id;
      var vSrc = (vImg.preview_image && vImg.preview_image.src) || vImg.src;
      media = media.slice().sort(function (a, b) {
        var aMatch = (a.id && a.id === vId) || ((a.preview_image && a.preview_image.src) || a.src) === vSrc;
        var bMatch = (b.id && b.id === vId) || ((b.preview_image && b.preview_image.src) || b.src) === vSrc;
        return (bMatch ? 1 : 0) - (aMatch ? 1 : 0);
      });
      var hasMatch = media.some(function (m) { return (m.id && m.id === vId) || ((m.preview_image && m.preview_image.src) || m.src) === vSrc; });
      if (!hasMatch) media = [{ id: vId, src: vSrc, preview_image: { src: vSrc } }].concat(media);
    }
    var shown = media.slice(0, 6);
    var slides = shown.map(function (m) {
      var src = (m.preview_image && m.preview_image.src) || m.src || m;
      return '<div class="mm-qd__slide"><img src="' + src + '" loading="lazy" alt=""></div>';
    }).join('');
    var nav = shown.length > 1 ?
      '<button type="button" class="mm-qd__mnav mm-qd__mnav--prev" data-mm-qd-media-prev aria-label="Previous image">' + CHEVRON_LEFT + '</button>' +
      '<button type="button" class="mm-qd__mnav mm-qd__mnav--next" data-mm-qd-media-next aria-label="Next image">' + CHEVRON_RIGHT + '</button>'
      : '';
    return '<div class="mm-qd__mediawrap">' +
             '<div class="mm-qd__media" data-mm-qd-media>' + slides + '</div>' +
             nav +
           '</div>';
  }

  function bindMediaNav() {
    var track = panel.querySelector('[data-mm-qd-media]');
    if (!track) return;
    var prev = panel.querySelector('[data-mm-qd-media-prev]');
    var next = panel.querySelector('[data-mm-qd-media-next]');
    if (!prev && !next) return;

    function step() {
      var slide = track.querySelector('.mm-qd__slide');
      return slide ? slide.getBoundingClientRect().width + 10 : Math.max(track.clientWidth * 0.8, 200);
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () {
      clearTimeout(track.__mmSyncT);
      track.__mmSyncT = setTimeout(sync, 80);
    });
    window.requestAnimationFrame(sync);
  }

  function optionName(opt, i) { return (opt && typeof opt === 'object') ? opt.name : opt; }
  function renderOptions(product) {
    if (product.has_only_default_variant) return '';
    return product.options.map(function (opt, i) {
      var name = optionName(opt, i);
      var values = [];
      if (opt && typeof opt === 'object' && opt.values) { values = opt.values.slice(); }
      else { product.variants.forEach(function (v) { if (values.indexOf(v.options[i]) === -1) values.push(v.options[i]); }); }
      var btns = values.map(function (val) {
        var sel = current.selected[i] === val ? ' is-selected' : '';
        return '<button type="button" class="mm-qd__swatch' + sel + '" data-mm-qd-opt="' + i + '" data-mm-qd-val="' + String(val).replace(/"/g, '&quot;') + '">' + val + '</button>';
      }).join('');
      return '<div class="mm-qd__optgroup"><span class="mm-qd__optlabel">' + name + '</span><div class="mm-qd__opts">' + btns + '</div></div>';
    }).join('');
  }

  function renderFooter(product) {
    var v = current.variant;
    var avail = v && v.available;
    var priceStr = v ? formatMoney(v.price) : '';
    var addLabel = !v ? 'Unavailable' : (avail ? ('Add to cart' + (priceStr ? ' • ' + priceStr : '')) : 'Sold out');
    return '' +
      '<button type="button" class="m-button m-button--primary mm-qd__add" data-mm-qd-add' + (avail ? '' : ' disabled') + '>' +
        '<span class="mm-qd__add-text">' + addLabel + '</span>' +
        '<span class="mm-qd__spin" hidden></span>' +
      '</button>' +
      '<button type="button" class="m-button m-button--secondary mm-qd__buy" data-mm-qd-buy' + (avail ? '' : ' disabled') + '>Buy it now</button>' +
      '<a class="mm-qd__more" href="' + product.url + '">View more details</a>';
  }

  function paint() {
    var product = current.product;
    var scroll = panel.querySelector('[data-mm-qd-scroll]');
    var footer = panel.querySelector('[data-mm-qd-footer]');
    scroll.innerHTML =
      renderMedia(product) +
      '<div class="mm-qd__body">' +
        '<h2 class="mm-qd__title">' + product.title + '</h2>' +
        '<div class="mm-qd__price" data-mm-qd-price>' + (current.variant ? formatMoney(current.variant.price) : '') + '</div>' +
        (current.variant && current.variant.available ? '<div class="mm-qd__stock is-in">In stock and ready to ship</div>' : (current.variant ? '<div class="mm-qd__stock is-out">Out of stock</div>' : '')) +
        renderOptions(product) +
      '</div>';
    footer.innerHTML = renderFooter(product);
    bindPanel();
  }

  function bindPanel() {
    panel.querySelectorAll('[data-mm-qd-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = Number(b.getAttribute('data-mm-qd-opt'));
        current.selected[i] = b.getAttribute('data-mm-qd-val');
        current.variant = findVariant(current.product);
        paint();
      });
    });
    bindMediaNav();
    var add = panel.querySelector('[data-mm-qd-add]');
    if (add) add.addEventListener('click', addToCart);
    var buy = panel.querySelector('[data-mm-qd-buy]');
    if (buy) buy.addEventListener('click', buyNow);
  }

  async function addToCart() {
    var v = current.variant;
    if (!v || !v.available) return;
    var btn = panel.querySelector('[data-mm-qd-add]');
    var txt = btn.querySelector('.mm-qd__add-text');
    var spin = btn.querySelector('.mm-qd__spin');
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading'); if (spin) spin.hidden = false;
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      });
      close();
      if (window.__mmRefreshCartDrawer) { await window.__mmRefreshCartDrawer(); }
      if (window.__mmEmitCartUpdate) {
        await window.__mmEmitCartUpdate('mm-quick-add-drawer');
      } else if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { source: 'mm-quick-add-drawer' });
      }
      var drawer = document.querySelector('#MinimogCartDrawer, .m-cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    } catch (e) {
    } finally {
      btn.classList.remove('is-loading'); if (spin) spin.hidden = true;
    }
  }

  function buyNow() {
    var v = current.variant;
    if (!v || !v.available) return;
    window.location.href = '/cart/' + v.id + ':1';
  }

  async function openForHandle(handle) {
    ensureDom();
    open();
    var scroll = panel.querySelector('[data-mm-qd-scroll]');
    var footer = panel.querySelector('[data-mm-qd-footer]');
    scroll.innerHTML = '<div class="mm-qd__loading">Loading…</div>';
    footer.innerHTML = '';
    try {
      var res = await fetch('/products/' + handle + '.js', { headers: { accept: 'application/json' } });
      var product = await res.json();
      current.product = product;
      current.selected = {};
      var first = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      product.options.forEach(function (name, i) { current.selected[i] = first.options[i]; });
      current.variant = first;
      paint();
    } catch (e) {
      scroll.innerHTML = '<div class="mm-qd__loading">Sorry, this product could not be loaded.</div>';
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mm-qa-open]');
    if (!t) return;
    e.preventDefault();
    var handle = t.getAttribute('data-product-handle');
    if (handle) openForHandle(handle);
  });

  window.mmQuickAddDrawer = { openForHandle: openForHandle, close: close };
})();

